import { lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';

// routes
import AuthenticationRoutes from './AuthenticationRoutes';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import SimpleRoutes from './SimpleRoutes';
import ChatRoutes from './ChatRoutes';
import BrainRoutes from './BrainRoutes';
// project imports
import Loadable from 'ui-component/Loadable';

const SplashScreen = Loadable(lazy(() => import('views/splash/SplashScreen')));

// ==============================|| SPLASH GATE ||============================== //
// Rewrite the URL to /splash on the first load of each browser tab so the splash
// is always the first screen the user sees. The original destination is preserved
// in the `next` query param so the splash can resume the user there on ENTER.
// Must run BEFORE createBrowserRouter is called below, since the router reads
// `location.pathname` once at creation time.
(function ensureSplashFirst() {
  if (typeof window === 'undefined') return;
  try {
    if (sessionStorage.getItem('phnx_splash_seen') === '1') return;
    const base = (import.meta.env.VITE_APP_BASE_NAME || '').replace(/\/$/, '');
    const path = window.location.pathname;
    const rel = base && path.startsWith(base) ? path.slice(base.length) || '/' : path;
    if (rel === '/splash') return;
    const next = encodeURIComponent(rel + window.location.search + window.location.hash);
    window.history.replaceState({}, '', `${base}/splash?next=${next}`);
  } catch {
    /* sessionStorage unavailable — fall through */
  }
})();

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [
    { path: '/', element: <Navigate to="/splash" replace /> },
    { path: '/splash', element: <SplashScreen /> },
    AuthenticationRoutes,
    LoginRoutes,
    SimpleRoutes,
    BrainRoutes,
    MainRoutes,
    ChatRoutes
  ],
  {
    basename: import.meta.env.VITE_APP_BASE_NAME
  }
);

export default router;
